import { makeModuleStateSelector } from "@client/content/selectors";
import { combinedSettingsSelector, TargetSelector } from "@client/selectors";
import { createSelector } from "reselect";
import { defaultState, previewState } from "./reducer";
import { type PackagePricing } from "./types";

export const localStateSelector = makeModuleStateSelector<PackagePricing.AppState>(defaultState, previewState);

export const getIdsSelector = () =>
  combinedSettingsSelector<PackagePricing.Ids>(TargetSelector.Entity, [
    { name: "package", prop: "packageId" },
    { name: "trial", prop: "trialId" }
  ]);

export const makeContentStyleSelector = () => {
  const settingsSelector = combinedSettingsSelector<{ gap: number }>(TargetSelector.Entity, ["gap"]);

  return createSelector(
    [settingsSelector],
    (settings): React.CSSProperties => ({
      ...settings
    })
  );
};

export const makeBlocksStyleSelector = () => {
  const settingsSelector = combinedSettingsSelector<{ gap: number; flexDirection: any }>(
    TargetSelector.Entity,
    ["gap", { name: "direction", prop: "flexDirection" }],
    "blocks"
  );

  return createSelector(
    [settingsSelector],
    (settings): React.CSSProperties => ({
      ...settings
    })
  );
};
